export interface Specialization {
  id: string
  areaId: string
  name: string
  xp: number
  createdAt: number
}

export const specializationNames = (
  categoryIds: string[],
  specializations: Specialization[],
) => categoryIds.map((id) => specializations.find((item) => item.id === id)?.name).filter((name): name is string => Boolean(name))
